module.exports = __webpack_public_path__ + "ls.f569fcb14688ea388411.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ls.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ls.svg
// module chunks = styles